import { Link } from "react-router-dom";

const AboutPage = () => (
  <>
    <h1>About</h1>
    <p>This is the about page</p>
    <p>
      <Link to="/dashboard">Go home</Link>
    </p>
  </>
);

export default AboutPage;
